import React, { useEffect } from "react";
import { create_checkout_session } from "../../api/backendApi";
import { EXPERT_YEARLY_ID } from "../../env";
import {NavbarContainer} from "../../components/templates/navbar/Navbar";


const ExpertYearlySubscription = () => {
    useEffect(async () => {
        await create_checkout_session(EXPERT_YEARLY_ID)
    });


    return (
        <div className="dark-bg-with-gradients" style={{ minHeight: 'calc(100vh - 203px)', display: 'flex', flexDirection: 'column' }}>
            <NavbarContainer/>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: '1' }}>
                <h1 style={{ color: '#FFF', fontSize: '21px' }}>You will be redirected to the Subscription Manager in a moment.</h1>
            </div>
        </div>
    );
}

export default ExpertYearlySubscription